import { createEntityQuery } from '@datorama/akita';
import store from './store';

export const query = createEntityQuery(store);
export const entities$ = query.selectAll();
export const loading$ = query.selectLoading();
